import React from 'react';
import ActiveFlag from './ActiveFlag';

export default ({className, url, title, active, dataCategory, dataAction, dataLabel, }) => {
    return (
        <div className={`position-relative ${className}`}>
            {!active ? null : <ActiveFlag className="pl-2 pt-3"/>}
            <a className="btn btn-link"
                data-category={dataCategory}
                data-action={dataAction}
                data-label={dataLabel}
                href={url}>
                <span className="h5 mb-0 font-weight-black">{title}</span>
            </a>
        </div>
    )
}
